import { locationActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  created: false,
  updated: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case locationActions.LOCATIONS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null
      };
    case locationActions.LOCATIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case locationActions.LOCATIONS_NEW:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: true,
        error: null
      };
    case locationActions.LOCATIONS_UPDATED:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: true,
        error: null
      };
    case locationActions.LOCATIONS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    case locationActions.LOCATIONS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        created: false,
        error: null
      };
    default:
      return state;
  }
};
